import api from '@/api/reports'
import errors from '@/api/errors'

const state = {
  // internal
  internal: {}
}

const getters = {
  // internal
  targetReviewId: state => state.internal.targetReviewId,
  targetCommentId: state => state.internal.targetCommentId
}

const mutations = {
  initialize: (state, args) => {
    state.internal = args
  }
}

const actions = {
  /**
   * 初期化
   */
  initialize: ({ commit }, args) => {
    commit('initialize', args)
  },
  /**
   * レビュー報告
   */
  reportReview: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      reviewId: args.reviewId,
      type: args.type,
      description: args.description
    }
    return api.reportReview(params).then(data => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      return data
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else if (error instanceof errors.InputValidationError) {
        return Promise.reject(Error(error.message))
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * コメント通報
   */
  reportComment: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      reviewId: args.reviewId,
      commentId: args.commentId,
      type: args.type,
      description: args.description
    }
    return api.reportReview(params).then(data => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      return data
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else if (error instanceof errors.InputValidationError) {
        return Promise.reject(Error(error.message))
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js